import useTranslator from "../hooks/useTranslator";
import CancelIcon from "../assets/img/cancel-01.svg";
import { useContext, useState } from "react";
import LandLordContext from "../context/landlord/LandLordContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "../helper/common";

const TopUpCreditModal = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { addCredit } = useContext(LandLordContext);
  const { workspaceId } = useParams();

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleAddCredit = () => {
    setButtonDisabled(true);
    addCredit({})
      .then((res) => {
        const data = res.success_res;
        window.location.replace(data?.paymentUrl);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error while adding credits");
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };

  const handleCreditHistory = () => {
    navigate(`/${workspaceId}/credits-ledger`);
    setOpen();
  };

  return (
    open && (
      <div
        className={`modal wrapper-modal fade top-up-credit-modal ${
          open ? "show d-block" : ""
        }`}
        onClick={setOpen}
      >
        <div
          className="modal-dialog"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title">{_t("topUpCredits")}</h5>
                <div className="cursor-pointer" onClick={setOpen}>
                  <img
                    src={CancelIcon}
                    alt="icon"
                    className="canceicon topRightIcon"
                  />
                </div>
              </div>
              <p>5 {_t("creditsWillBeUsedToViewEachTenantProfile")}</p>
            </div>
            <div className="modal-body">
              <div className="top-up-credit-icon d-flex align-items-center justify-content-center">
                <img src="/images/pointIcon.svg" />
              </div>
              <span className="credit-score">20 {_t("credits")}</span>
              <div class="credit-score-card">
                <div class="credit-score-text">x4 {_t("profileViews")}</div>
                <div class="credit-score-price">
                  {_t("price")}:<span>€100</span>
                </div>
              </div>
              <div className="d-flex justify-content-around w-100">
                <button
                  onClick={handleCreditHistory}
                  className="addGuarantorButton modal-btn btn-grey"
                >
                  {_t("creditsLedger")}
                </button>
                <button
                  onClick={handleAddCredit}
                  className="addGuarantorButton modal-btn"
                  disabled={buttonDisabled}
                >
                  {_t("continueToBuy")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default TopUpCreditModal;
